import { Component, OnInit, Input } from '@angular/core';
import { HelpNav } from "../../../models/help-library.model";

@Component({
    selector: 'help-navigation-item',
    templateUrl: './help-navigation-item.component.html',
    styleUrls: ['./help-navigation-item.component.scss'],
    standalone: false
})
export class HelpNavigationItemComponent implements OnInit {

    @Input() item: HelpNav;

    constructor() { }

    ngOnInit() {
        
    }

}
